import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as proposalService from '../../../../services/service/proposalService';
import { Link } from 'react-router-dom';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Form } from "react-bootstrap";
import * as userService from "../../../../services/management/userService";
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../../redux/confirmModalRedux";
import * as helper from "../../../../helpers/helper";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import * as unitOfCostService from "../../../../services/management/unitOfCostService";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from 'react-select'
import { useFormik } from "formik";
import ScheduleOfChargeValidator from '../../../../helpers/validators/ScheduleOfChargeValidator';
import constants from '../../../../constants/constants';

const ProposalContentPage = (props) => {
    const initalScheduleOfCharge = {
        service: '',
        cost: '',
        unitOfCostId: null
    };

    const { proposalIdParam, showAlert, proposalPermission, showConfirmModal, hideConfirmModal, setProcessing, auth, isReadOnly } = props;
    const [loading, setLoading] = useState(false);
    const [scopeOfWorkText, setScopeOfWorkText] = useState("");
    const [exclusionText, setExclusionText] = useState("");
    const [unitOfCostOptions, setUnitOfCostOptions] = useState([]);
    const [isSecondaryHeader, setIsSecondaryHeader] = useState(false);
    const [scheduleOfCharge, setScheduleOfCharge] = useState(initalScheduleOfCharge);
    const [proposalCostNotToExceed, setProposalCostNotToExceed] = useState(initalScheduleOfCharge);
    const [unitOfCostSelected, setUnitOfCostSelected] = useState(null);
    const [userList, setUserList] = useState([]);
    const [selectedSignatureUser, setSelectedSignatureUser] = useState(null);
    const [selectedUserSignatureImageUrl, setSelectedUserSignatureImageUrl] = useState(null);

    const [proposal, setProposal] = useState({
        proposalHeader: '',
        scheduleAndCharges: '',
        proposalSenderSignatureUserId: '',
        scopeOfWorks: [],
        proposalCostNotToExceeds: [],
        proposalExclusions: [],
        scheduleOfCharges: []
    });

    useEffect(() => {
        unitOfCostService.getUnitOfCosts().then(res => {
            setUnitOfCostOptions(res.map(x => helper.setToOptionModel(x.unit, x.id)));
            loadUserList().then(users => {
                loadProposalContent(users);
            })
        });
    }, []);

    const getSignatureOfUser = (userId) => {
        userService.getUserProfile(userId).then(res => {
            setSelectedUserSignatureImageUrl((res.signatureImageUrl) ? constants.API_URL + res.signatureImageUrl : null);
        });
    }

    const loadUserList = () => userService.getAllUsers(false).then(res => {
        let allUsers = res.map(x => { return { ...x, role: x.role.split(',') } });
        allUsers = allUsers.filter(x => (x.role.includes("Admin") || x.role.includes("Project Manager")));
        var options = allUsers.map(x => helper.setToOptionModel(x.fullName, x.id));
        setUserList(options);

        return options;
    });

    const loadProposalContent = (users) => {
        proposalService.GetProposalById(proposalIdParam).then(res => {
            setIsSecondaryHeader(res.isSecondaryHeader ? res.isSecondaryHeader : false)
            setProposal({
                ...res,
                isSecondaryHeader: res.isSecondaryHeader ? res.isSecondaryHeader : false,
                scopeOfWorks: res.scopeOfWorks ? res.scopeOfWorks.sort((a, b) => a.sortOrder - b.sortOrder) : [],
                scheduleOfCharges: res.scheduleOfCharges ? res.scheduleOfCharges.sort((a, b) => a.sortOrder - b.sortOrder) : [],
                proposalCostNotToExceeds: res.proposalCostNotToExceeds ? res.proposalCostNotToExceeds.sort((a, b) => a.sortOrder - b.sortOrder) : [],
                proposalExclusions: res.proposalExclusions ? res.proposalExclusions.sort((a, b) => a.sortOrder - b.sortOrder) : [],
            });
            if (res.proposalSenderSignatureUserId) {
                getSignatureOfUser(res.proposalSenderSignatureUserId);
                setSelectedSignatureUser(users.find(x => x.value == res.proposalSenderSignatureUserId));
            }
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
    }

    const deleteScopeOfWork = (id, sortOrder) => {
        let tempArr = [...proposal.scopeOfWorks];
        _.remove(tempArr, {
            id: id,
            sortOrder: sortOrder
        });

        setProposal({ ...proposal, scopeOfWorks: tempArr });
        hideConfirmModal();
    }

    const deleteExclusion = (id, sortOrder) => {
        let tempArr = [...proposal.proposalExclusions];
        _.remove(tempArr, {
            id: id,
            sortOrder: sortOrder
        });

        setProposal({ ...proposal, proposalExclusions: tempArr });
        hideConfirmModal();
    }

    const deleteCostNotToExceed = (id, sortOrder) => {
        let tempArr = [...proposal.proposalCostNotToExceeds];
        _.remove(tempArr, {
            id: id,
            sortOrder: sortOrder
        });

        setProposal({ ...proposal, proposalCostNotToExceeds: tempArr });
        hideConfirmModal();
    }

    const deleteScheduleOfCharges = (id, sortOrder) => {
        let tempArr = [...proposal.scheduleOfCharges];
        _.remove(tempArr, {
            id: id,
            sortOrder: sortOrder
        });

        setProposal({ ...proposal, scheduleOfCharges: tempArr });
        hideConfirmModal();
    }

    const onScopeDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const tempArr = helper.reOrderDnd(
            proposal.scopeOfWorks,
            result.source.index,
            result.destination.index
        );

        setProposal({ ...proposal, scopeOfWorks: tempArr });
    };

    const onExclusionDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const tempArr = helper.reOrderDnd(
            proposal.proposalExclusions,
            result.source.index,
            result.destination.index
        );

        setProposal({ ...proposal, proposalExclusions: tempArr });
    };

    const onScheduleOfChargeDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const tempArr = helper.reOrderDnd(
            proposal.scheduleOfCharges,
            result.source.index,
            result.destination.index
        );

        setProposal({ ...proposal, scheduleOfCharges: tempArr });
    }

    const onProposalNotToExceedDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const tempArr = helper.reOrderDnd(
            proposal.proposalCostNotToExceeds,
            result.source.index,
            result.destination.index
        );

        setProposal({ ...proposal, proposalCostNotToExceeds: tempArr });
    }

    const addScope = () => {
        setProposal({
            ...proposal,
            scopeOfWorks: [...proposal.scopeOfWorks, { id: 0, sortOrder: proposal.scopeOfWorks.length, text: scopeOfWorkText, proposalId: proposal.id }]
        });

        setScopeOfWorkText("");
    }

    const addExclusion = () => {
        setProposal({
            ...proposal,
            proposalExclusions: [...proposal.proposalExclusions, { id: 0, sortOrder: proposal.proposalExclusions.length, text: exclusionText, proposalId: proposal.id }]
        });

        setExclusionText("");
    }

    const saveProposal = () => {
        setLoading(true);
        proposalService.SaveProposal(proposal).then(res => {
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(res => {
            setLoading(false);
        })
    }

    const formik = useFormik({
        initialValues: scheduleOfCharge,
        enableReinitialize: true,
        validationSchema: ScheduleOfChargeValidator,
        onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
            setProposal({ ...proposal, scheduleOfCharges: [...proposal.scheduleOfCharges, { ...values, id: 0, proposalId: proposal.id, sortOrder: proposal.scheduleOfCharges.length + 1 }] });
            setUnitOfCostSelected(null);
            resetForm();
        }
    });

    const formik_nottoexceed = useFormik({
        initialValues: proposalCostNotToExceed,
        enableReinitialize: true,
        validationSchema: ScheduleOfChargeValidator,
        onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
            setProposal({ ...proposal, proposalCostNotToExceeds: [...proposal.proposalCostNotToExceeds, { ...values, id: 0, proposalId: proposal.id, sortOrder: proposal.proposalCostNotToExceeds.length + 1 }] });
            setUnitOfCostSelected(null);
            resetForm();
        },
    });


    return (
        <>
            <div className="card card-custom" >
                {loading && <ModalProgressBar />}
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Proposal Content
                        </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            View & Edit Proposal Content that gets sent to client
                        </span>
                    </div>
                    {
                        !isReadOnly &&
                        <div className="card-toolbar">
                            <button
                                onClick={saveProposal}
                                disabled={loading}
                                className="btn btn-success mr-2"
                            >
                                Save Changes
                            </button>
                            <a className="btn btn-info" href={constants.API_URL + "api/Proposal/GetProposalPdf?proposalId=" + proposalIdParam + '&token=' + auth.authToken} target="_blank">
                                Preview Proposal
                            </a> &nbsp;&nbsp;
                            <Link
                                to="/services/proposals"
                                className="btn btn-secondary"
                            >
                                Cancel
                            </Link>
                        </div>
                    }
                </div>
                <div className="form">
                    <div className="card-body">
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Proposal Header</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className='d-block w-100'>
                                    <label className="checkbox checkbox-primary">
                                        <input
                                            checked={isSecondaryHeader}
                                            type="checkbox"
                                            name="SecondaryHeader"
                                            onChange={() => {
                                                setProposal({ ...proposal, isSecondaryHeader: !isSecondaryHeader })
                                                setIsSecondaryHeader(!isSecondaryHeader);
                                            }}
                                        />
                                        <span> </span> &nbsp; Use Secondary Header?
                                    </label>
                                    <Form.Control as="textarea" rows="17"
                                        readOnly={isReadOnly}
                                        value={proposal.proposalHeader}
                                        onChange={(e) => setProposal({ ...proposal, proposalHeader: e.target.value })}
                                        placeholder="Start typing Proposal Header..."
                                        className={`form-control form-control-lg form-control-solid mt-10`}
                                        name="proposalHeader"
                                    />
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Scope Of Work</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="w-100">
                                    {
                                        !isReadOnly &&
                                        <div className="d-flex w-100 justify-content-between align-items-center">
                                            <div className="" style={{ width: '85%' }}>
                                                <Form.Control
                                                    as="textarea"
                                                    rows="2"
                                                    value={scopeOfWorkText}
                                                    onChange={e => setScopeOfWorkText(e.target.value)}
                                                    placeholder="Start typing Scope of Work..."
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="proposalHeader"
                                                />
                                            </div>
                                            <div className="">
                                                <button onClick={addScope} className="btn btn-primary">Add Scope</button>
                                            </div>
                                        </div>
                                    }
                                    <div className="w-100 mt-5">
                                        {
                                            proposal.scopeOfWorks.length == 0 ?
                                                <div className="contact-log-block-container">
                                                    <div className="user-info-block">
                                                        <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                            No Scope of Work Available
                                                        </a>
                                                    </div>
                                                </div>
                                                :
                                                <List>
                                                    <DragDropContext onDragEnd={onScopeDragEnd}>
                                                        <Droppable droppableId="droppable">
                                                            {(droppableProvided, droppableSnapshot) => (
                                                                <div
                                                                    ref={droppableProvided.innerRef}
                                                                    style={helper.getListStyleDnd(droppableSnapshot.isDraggingOver)}
                                                                >
                                                                    {proposal.scopeOfWorks.map((item, index) => (
                                                                        <Draggable key={index} draggableId={index + ""} index={index}>
                                                                            {(draggableProvided, draggableSnapshot) => (
                                                                                <ListItem key={item.id} dense button
                                                                                    ref={draggableProvided.innerRef}
                                                                                    {...draggableProvided.draggableProps}
                                                                                    {...draggableProvided.dragHandleProps}
                                                                                    style={helper.getItemStyleDnd(
                                                                                        draggableSnapshot.isDragging,
                                                                                        draggableProvided.draggableProps.style
                                                                                    )}
                                                                                >
                                                                                    <ListItemText style={{ width: '95%', flex: 'none' }} primary={`${item.text}`} />

                                                                                    <ListItemSecondaryAction>
                                                                                        {
                                                                                            !isReadOnly &&
                                                                                            <IconButton edge="end" onClick={() => showConfirmModal({
                                                                                                title: "Delete Scope of Work",
                                                                                                text: "Are you sure you want to delete this Scope of work?",
                                                                                                rightBtnText: "Confirm",
                                                                                                btnAction: () => deleteScopeOfWork(item.id, item.sortOrder)
                                                                                            })}>
                                                                                                <HighlightOffIcon />
                                                                                            </IconButton>
                                                                                        }
                                                                                    </ListItemSecondaryAction>

                                                                                </ListItem>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}
                                                                    {droppableProvided.placeholder}
                                                                </div>
                                                            )}
                                                        </Droppable>
                                                    </DragDropContext>
                                                </List>
                                        }
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        {/* EXCLUSIONS */}
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Exclusions</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="w-100">
                                    {
                                        !isReadOnly &&
                                        <div className="d-flex w-100 justify-content-between align-items-center">
                                            <div className="" style={{ width: '85%' }}>
                                                <Form.Control
                                                    as="textarea"
                                                    rows="2"
                                                    value={exclusionText}
                                                    onChange={e => setExclusionText(e.target.value)}
                                                    placeholder="Start Typing Exclusions..."
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="exclusions"
                                                />
                                            </div>
                                            <div className="">
                                                <button onClick={addExclusion} className="btn btn-primary">Add Exclusion</button>
                                            </div>
                                        </div>
                                    }
                                    <div className="w-100 mt-5">
                                        {
                                            proposal.proposalExclusions.length == 0 ?
                                                <div className="contact-log-block-container">
                                                    <div className="user-info-block">
                                                        <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                            No Exclusions Available
                                                        </a>
                                                    </div>
                                                </div>
                                                :
                                                <List>
                                                    <DragDropContext onDragEnd={onExclusionDragEnd}>
                                                        <Droppable droppableId="droppable">
                                                            {(droppableProvided, droppableSnapshot) => (
                                                                <div
                                                                    ref={droppableProvided.innerRef}
                                                                    style={helper.getListStyleDnd(droppableSnapshot.isDraggingOver)}
                                                                >
                                                                    {proposal.proposalExclusions.map((item, index) => (
                                                                        <Draggable key={index} draggableId={index + ""} index={index}>
                                                                            {(draggableProvided, draggableSnapshot) => (
                                                                                <ListItem key={item.id} dense button
                                                                                    ref={draggableProvided.innerRef}
                                                                                    {...draggableProvided.draggableProps}
                                                                                    {...draggableProvided.dragHandleProps}
                                                                                    style={helper.getItemStyleDnd(
                                                                                        draggableSnapshot.isDragging,
                                                                                        draggableProvided.draggableProps.style
                                                                                    )}
                                                                                >
                                                                                    <ListItemText style={{ width: '95%', flex: 'none' }} primary={`${item.text}`} />
                                                                                    <ListItemSecondaryAction>
                                                                                        {
                                                                                            !isReadOnly &&
                                                                                            <IconButton edge="end" onClick={() => showConfirmModal({
                                                                                                title: "Delete Exclusion",
                                                                                                text: "Are you sure you want to delete this Exclusion?",
                                                                                                rightBtnText: "Confirm",
                                                                                                btnAction: () => deleteExclusion(item.id, item.sortOrder)
                                                                                            })}>
                                                                                                <HighlightOffIcon />
                                                                                            </IconButton>
                                                                                        }
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}
                                                                    {droppableProvided.placeholder}
                                                                </div>
                                                            )}
                                                        </Droppable>
                                                    </DragDropContext>
                                                </List>
                                        }
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Schedule & Charges</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Form.Control as="textarea" rows="10"
                                    readOnly={isReadOnly}
                                    value={proposal.scheduleAndCharges}
                                    onChange={(e) => setProposal({ ...proposal, scheduleAndCharges: e.target.value })}
                                    placeholder="Start typing Schedule And Charges..."
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="scheduleAndCharges"
                                />
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {/* PROPOSAL SIGNATURE */}
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Proposal Signature</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="w-100">
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-100">
                                            Signature
                                        </label>
                                        <div className="col-lg-12 col-xl-9">
                                            <Select
                                                value={selectedSignatureUser}
                                                options={userList}
                                                isDisabled={isReadOnly}
                                                menuPlacement={'auto'}
                                                onChange={selectedOption => {
                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                    getSignatureOfUser(selectedOption.value);
                                                    setSelectedSignatureUser(selectedOption);
                                                    setProposal({ ...proposal, proposalSenderSignatureUserId: selectedOption.value });
                                                }}
                                                name="signature"
                                                placeholder="Select User whose Signature is to be selected"
                                            />
                                            {
                                                selectedUserSignatureImageUrl &&
                                                <>
                                                    <br />
                                                    <img src={selectedUserSignatureImageUrl} />
                                                </>
                                            }
                                            {
                                                selectedUserSignatureImageUrl === null && selectedSignatureUser !== null &&
                                                <>
                                                    <p style={{ color: "#ee6969" }}>
                                                        This user does not have a signature uploaded. Please upload a signature for this user
                                                    </p>
                                                    <a href={"/management/user-profile/personal-information/" + selectedSignatureUser.value} target="_blank">Click Here to upload signature</a>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-100">
                                            Name
                                        </label>
                                        <div className="col-lg-12 col-xl-9">
                                            <input
                                                readOnly={isReadOnly}
                                                value={proposal.proposalSenderName}
                                                type="text"
                                                placeholder="Enter proposal creator name"
                                                onChange={(e) => setProposal({ ...proposal, proposalSenderName: e.target.value })}
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="name"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-100">
                                            Title
                                        </label>
                                        <div className="col-lg-12 col-xl-9">
                                            <input
                                                readOnly={isReadOnly}
                                                value={proposal.proposalSenderTitle}
                                                type="text"
                                                placeholder="Enter proposal creator title"
                                                onChange={(e) => setProposal({ ...proposal, proposalSenderTitle: e.target.value })}
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="title"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Schedule Of Charges</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="w-100">
                                    {
                                        !isReadOnly &&
                                        <form
                                            onSubmit={formik.handleSubmit}
                                        >
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <div className="" style={{ width: '50%' }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Service Name"
                                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "service")}`}
                                                        {...formik.getFieldProps("service")}
                                                    />
                                                    {formik.touched.service && formik.errors.service ? (
                                                        <div className="invalid-feedback">{formik.errors.service}</div>
                                                    ) : null}
                                                </div>
                                                <div className="" style={{ width: '15%' }}>
                                                    <input
                                                        type="number"
                                                        placeholder="Cost"
                                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik, "cost")}`}
                                                        {...formik.getFieldProps("cost")}
                                                    />
                                                    {formik.touched.cost && formik.errors.cost ? (
                                                        <div className="invalid-feedback">{formik.errors.cost}</div>
                                                    ) : null}
                                                </div>
                                                <div className="" style={{ width: '20%' }}>
                                                    <Select
                                                        value={unitOfCostSelected}
                                                        options={unitOfCostOptions}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setUnitOfCostSelected(selectedOption);
                                                            formik.setFieldValue("unitOfCostId", selectedOption.value);
                                                        }}
                                                        className={`${helper.getInputClasses(formik, "unitOfCostId")}`}
                                                        placeholder="Unit Of Cost"
                                                    />
                                                    {formik.touched.unitOfCostId && formik.errors.unitOfCostId ? (
                                                        <div className="invalid-feedback">{formik.errors.unitOfCostId}</div>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex justify-content-end" style={{ width: '10%' }}>
                                                    <button type="submit" className="btn btn-primary btn-block">Add</button>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                    <div className="w-100 mt-5">
                                        {
                                            proposal.scheduleOfCharges.length == 0 ?
                                                <div className="contact-log-block-container">
                                                    <div className="user-info-block">
                                                        <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                            No Schedule Of Charges Available
                                                        </a>
                                                    </div>
                                                </div>
                                                :
                                                <>
                                                    <div className="d-flex">
                                                        <div style={{ width: '50%' }}>
                                                            <h5><u><strong>Service</strong></u></h5>
                                                        </div>
                                                        <div className="d-flex justify-content-end" style={{ width: '50%' }}>
                                                            <h5><u><strong>Cost</strong></u></h5>
                                                        </div>
                                                    </div>
                                                    <List>
                                                        <DragDropContext onDragEnd={onScheduleOfChargeDragEnd}>
                                                            <Droppable droppableId="droppable-schedule-of-charge">
                                                                {(droppableProvided, droppableSnapshot) => (
                                                                    <div
                                                                        ref={droppableProvided.innerRef}
                                                                        style={helper.getListStyleDnd(droppableSnapshot.isDraggingOver)}
                                                                    >
                                                                        {proposal.scheduleOfCharges.map((item, index) => (
                                                                            <Draggable key={index} draggableId={index + ""} index={index}>
                                                                                {(draggableProvided, draggableSnapshot) => (
                                                                                    <ListItem key={item.id} dense button
                                                                                        ref={draggableProvided.innerRef}
                                                                                        {...draggableProvided.draggableProps}
                                                                                        {...draggableProvided.dragHandleProps}
                                                                                        style={helper.getItemStyleDnd(
                                                                                            draggableSnapshot.isDragging,
                                                                                            draggableProvided.draggableProps.style
                                                                                        )}
                                                                                    >
                                                                                        <ListItemText style={{ width: '85%', flex: 'none' }} primary={item.service} />

                                                                                        <ListItemSecondaryAction>
                                                                                            <span>${item.cost}/{unitOfCostOptions.find(x => x.value == item.unitOfCostId).label}</span>

                                                                                            {
                                                                                                !isReadOnly &&
                                                                                                <IconButton edge="end" onClick={() => showConfirmModal({
                                                                                                    title: "Delete Schedule Of Charge",
                                                                                                    text: "Are you sure you want to delete this Schedule Of Charge?",
                                                                                                    rightBtnText: "Confirm",
                                                                                                    btnAction: () => deleteScheduleOfCharges(item.id, item.sortOrder)
                                                                                                })}>
                                                                                                    <HighlightOffIcon />
                                                                                                </IconButton>
                                                                                            }
                                                                                        </ListItemSecondaryAction>
                                                                                    </ListItem>
                                                                                )}
                                                                            </Draggable>
                                                                        ))}
                                                                        {droppableProvided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    </List>
                                                </>
                                        }
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        {/* COST NOT TO EXCEED */}
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Cost Not To Exceed</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="w-100">
                                    {
                                        !isReadOnly &&
                                        <form
                                            onSubmit={formik_nottoexceed.handleSubmit}
                                        >
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <div className="" style={{ width: '50%' }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Service Name"
                                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik_nottoexceed, "service")}`}
                                                        {...formik_nottoexceed.getFieldProps("service")}
                                                    />
                                                    {formik_nottoexceed.touched.service && formik_nottoexceed.errors.service ? (
                                                        <div className="invalid-feedback">{formik_nottoexceed.errors.service}</div>
                                                    ) : null}
                                                </div>
                                                <div className="" style={{ width: '15%' }}>
                                                    <input
                                                        type="number"
                                                        placeholder="Cost"
                                                        className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik_nottoexceed, "cost")}`}
                                                        {...formik_nottoexceed.getFieldProps("cost")}
                                                    />
                                                    {formik_nottoexceed.touched.cost && formik_nottoexceed.errors.cost ? (
                                                        <div className="invalid-feedback">{formik_nottoexceed.errors.cost}</div>
                                                    ) : null}
                                                </div>
                                                <div className="" style={{ width: '20%' }}>
                                                    <Select
                                                        value={unitOfCostSelected}
                                                        options={unitOfCostOptions}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setUnitOfCostSelected(selectedOption);
                                                            formik_nottoexceed.setFieldValue("unitOfCostId", selectedOption.value);
                                                        }}
                                                        className={`${helper.getInputClasses(formik_nottoexceed, "unitOfCostId")}`}
                                                        placeholder="Unit Of Cost"
                                                    />
                                                    {formik_nottoexceed.touched.unitOfCostId && formik_nottoexceed.errors.unitOfCostId ? (
                                                        <div className="invalid-feedback">{formik_nottoexceed.errors.unitOfCostId}</div>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex justify-content-end" style={{ width: '10%' }}>
                                                    <button type="submit" className="btn btn-primary btn-block">Add</button>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                    <div className="w-100 mt-5">
                                        {
                                            proposal.proposalCostNotToExceeds.length == 0 ?
                                                <div className="contact-log-block-container">
                                                    <div className="user-info-block">
                                                        <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                            No Cost Not To Exceed Available
                                                        </a>
                                                    </div>
                                                </div>
                                                :
                                                <>
                                                    <div className="d-flex">
                                                        <div style={{ width: '50%' }}>
                                                            <h5><u><strong>Service</strong></u></h5>
                                                        </div>
                                                        <div className="d-flex justify-content-end" style={{ width: '50%' }}>
                                                            <h5><u><strong>Cost</strong></u></h5>
                                                        </div>
                                                    </div>
                                                    <List>
                                                        <DragDropContext onDragEnd={onProposalNotToExceedDragEnd}>
                                                            <Droppable droppableId="droppable-schedule-of-charge">
                                                                {(droppableProvided, droppableSnapshot) => (
                                                                    <div
                                                                        ref={droppableProvided.innerRef}
                                                                        style={helper.getListStyleDnd(droppableSnapshot.isDraggingOver)}
                                                                    >
                                                                        {proposal.proposalCostNotToExceeds.map((item, index) => (
                                                                            <Draggable key={index} draggableId={index + ""} index={index}>
                                                                                {(draggableProvided, draggableSnapshot) => (
                                                                                    <ListItem key={item.id} dense button
                                                                                        ref={draggableProvided.innerRef}
                                                                                        {...draggableProvided.draggableProps}
                                                                                        {...draggableProvided.dragHandleProps}
                                                                                        style={helper.getItemStyleDnd(
                                                                                            draggableSnapshot.isDragging,
                                                                                            draggableProvided.draggableProps.style
                                                                                        )}
                                                                                    >
                                                                                        <ListItemText style={{ width: '85%', flex: 'none' }} primary={item.service} />

                                                                                        <ListItemSecondaryAction>
                                                                                            <span>${item.cost}/{unitOfCostOptions.find(x => x.value == item.unitOfCostId).label}</span>

                                                                                            {
                                                                                                !isReadOnly &&
                                                                                                <IconButton edge="end" onClick={() => showConfirmModal({
                                                                                                    title: "Delete Cost Not To Exceed",
                                                                                                    text: "Are you sure you want to delete this Cost Not To Exceed?",
                                                                                                    rightBtnText: "Confirm",
                                                                                                    btnAction: () => deleteCostNotToExceed(item.id, item.sortOrder)
                                                                                                })}>
                                                                                                    <HighlightOffIcon />
                                                                                                </IconButton>
                                                                                            }
                                                                                        </ListItemSecondaryAction>
                                                                                    </ListItem>
                                                                                )}
                                                                            </Draggable>
                                                                        ))}
                                                                        {droppableProvided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    </List>
                                                </>
                                        }
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    userProfileState: state.userProfile,
    auth: state.auth
});


export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(ProposalContentPage);